import { useState, type FormEvent } from 'react'
import { ArrowRight, LockKeyhole } from 'lucide-react'
import { api } from './api'
import { Button, Field, Notice, TextInput } from './components'
import type { User } from './types'

export function Login({ onAuthenticated, notice }: { onAuthenticated: (user: User) => void; notice?: string }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      const result = await api.login(email, password)
      onAuthenticated(result.user)
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Sign in failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="login-page">
      <section className="login-brand" aria-label="ExtraNPCs Studio">
        <img src="/brand/extranpcs-horizontal-dark.svg" alt="ExtraNPCs Living City Studio" />
        <div className="login-statement">
          <span className="eyebrow">World authoring</span>
          <h1>Build a city that feels alive before the player arrives.</h1>
          <p>One secure place for persistent people, shared events, spatial dialogue, world semantics, and atomic publication.</p>
        </div>
        <div className="route-motif" aria-hidden="true"><span /><span /><span /></div>
      </section>
      <section className="login-panel">
        <form onSubmit={submit} className="login-form">
          <div className="login-mark"><LockKeyhole size={22} /><span>Administrative access</span></div>
          <h2>Welcome back</h2>
          <p>Use your ExtraNPCs Studio administrator account.</p>
          {notice && <Notice kind="error">{notice}</Notice>}
          {error && <Notice kind="error">{error}</Notice>}
          <Field label="Email"><TextInput type="email" autoComplete="username" value={email} onChange={(event) => setEmail(event.target.value)} required autoFocus /></Field>
          <Field label="Password"><TextInput type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></Field>
          <Button type="submit" disabled={busy}>{busy ? 'Signing in…' : <>Sign in <ArrowRight size={17} /></>}</Button>
          <small>Sessions expire after inactivity. Publishing credentials never enter this browser.</small>
        </form>
      </section>
    </main>
  )
}
